export default {"src":"/_next/static/media/arrow.4ce97246.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};